import { format } from 'date-fns';

interface DayItemProps {
    day: Date;
    startDate: Date | null;
    endDate: Date | null;
    onClick: (day: Date) => void;
    width: number;
}

const DayItem: React.FC<DayItemProps> = ({ day, startDate, endDate, onClick, width }) => {
    const isWeekend = (date: Date) => date.getDay() === 0 || date.getDay() === 6;
    const isInRange = startDate && endDate && day > startDate && day < endDate;
    const isStart = startDate && format(day, 'yyyy-MM-dd') === format(startDate, 'yyyy-MM-dd');
    const isEnd = endDate && format(day, 'yyyy-MM-dd') === format(endDate, 'yyyy-MM-dd');
    const isSingleSelected = startDate && !endDate && format(day, 'yyyy-MM-dd') === format(startDate, 'yyyy-MM-dd');
    
    const dayClass = [
        'day_item',
        isInRange ? 'in-range' : '',
        isStart ? 'range-start' : '',
        isEnd ? 'range-end' : '',
        isSingleSelected ? 'single-selected' : ''
    ].join(' ');
    
    const weekDayShortNames = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'];
    
    return (
        <div className={dayClass} style={{width: width}} onClick={() => onClick(day)}>
            <div className="dayNum">{format(day, 'd')}</div>
            <div
                className="day_label"
                style={{ color: isWeekend(day) ? '#8e0606' : 'inherit' }}
            >
                {weekDayShortNames[day.getDay()]}
            </div>
        </div>
    );
};

export default DayItem;